<script>
import AppLoading from "@/components/elements/AppLoading.vue";
import {mapActions, mapGetters} from "vuex";
import {permissionMixin} from "@/mixins/permissionMixins";

export default {
  name: "NumberOfInjuriesByRank",
  mixins:[permissionMixin],
  components: {AppLoading},
  data() {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 6 }, (_, i) => currentYear - 5 + i);
    return {
      years,
      series: [],
      injuryData : [],
      chartOptions: {
        chart: {
          type: 'bar',
          events:{
            xAxisLabelClick: function(event, chartContext, config){
              if (this.isAllowed('menu.reports.accident-incident') === false) {
                return;
              }
              const data = [];
              this.series.forEach(item => {
                const metaData = item.meta_data;
                if (metaData[config.labelIndex].length > 0) {
                  metaData[config.labelIndex].forEach(value => {
                    data.push(value);
                  })
                }
              })
              this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_DATA_LOADING', true);
              $('#safetyAndHealthModal').modal('show');
              const data_table = {
                text_header : `Number of Injuries (${this.chartOptions.xaxis.categories[config.labelIndex]})`,
                safety_and_health_module : 'number_of_injuries_by_rank',
                data : data
              };
              this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_CHART_DATA', data_table)
              this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_DATA_LOADING', false);
            }.bind(this)
          }
        },
        title: {
          text: 'NUMBER OF INJURY (BY RANK)',
          align: 'center',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            vertical: true,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          colors: ['#000']
        },
        tooltip: {
          followCursor : true,
          shared: true,
          intersect: false
        },
        fill: {
          colors: ['#bfbfbf', '#a6a6a6', '#ffd966', '#f7caac', '#f4b083', '#ff0000']
        },
        grid: {
          borderColor: '#e9e9e9',
          position: 'front',
          xaxis: {
            lines: {
              show: true,
            }
          }
        },
        xaxis: {
          categories: [],
        },
      },
    }
  },
  methods : {
    ...mapActions([
      'getAccidentSafetyAndHealthChartsData',
    ])
  },
  mounted() {
    const yearsColors=['#bfbfbf','#a6a6a6','#ffd966','#f7caac','#f4b083','#ff0000']

    this.injuryData = this.injury_and_illnesses.filter(item => {
      return item.name.toLowerCase() === 'injuries';
    })[0];

    const categories = [...new Set(this.injuryData.data.map(item => {
      return item.values;
    }).flat().map(item => item.rank.toUpperCase()))];

    this.chartOptions.xaxis.categories = categories;

    this.years.forEach((year, index) => {
      const injuredByYear = this.injuryData.data.filter(item => {
          return item.year === year;
        })
      let yearData = categories.map(category => {
        return injuredByYear[0].values.filter(value => {
          return value.rank.toLowerCase() === category.toLowerCase()
        });
      });

      this.series.push({
        color : yearsColors[index],
        name : year,
        data : yearData.map(item => item.length),
        meta_data : yearData
      })
    })
  },
  computed : {
    ...mapGetters([
      'airSafetyAndHealthGraphDataLoading',
      'injury_and_illnesses',
      'cmsRequestedOnBoardCrew',
    ]),
  },
}
</script>

<template>
  <div>
    <div v-if="airSafetyAndHealthGraphDataLoading">
      <app-loading></app-loading>
    </div>
    <div v-else>
      <apexchart
        type="bar"
        :height="chartOptions.xaxis.categories.length * 35"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>

  </div>
</template>

<style scoped>

</style>
